import { useApi, PageHeader, Panel, Empty, Loading, ErrorNote } from "../components/kit";
import { CourseCard } from "../components/CourseCard";

export default function Training() {
  const { data, loading, error } = useApi("/my/assignments");
  if (loading) return <Loading />;
  const groups = [
    ["Overdue", (data || []).filter((a) => a.state === "overdue")],
    ["To do", (data || []).filter((a) => ["not_started", "in_progress", "awaiting_signoff"].includes(a.state))],
    ["Completed", (data || []).filter((a) => a.state === "completed")],
  ];
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Learning" title="My Training" testid="training-header" />
      <ErrorNote error={error} />
      {(data || []).length === 0 && <Empty testid="training-empty">No training has been assigned to you yet.</Empty>}
      {groups.map(([label, items]) => items.length > 0 && (
        <Panel key={label} title={`${label} (${items.length})`} testid={`training-group-${label.toLowerCase().replace(" ", "-")}`}>
          <div className="grid min-w-0 gap-4 sm:grid-cols-2 xl:grid-cols-3">{items.map((a) => <CourseCard key={a.id} a={a} />)}</div>
        </Panel>
      ))}
    </div>
  );
}
